<template>
  <v-layout class="flex-column">
    <v-layout wrap fill-height v-if="market">
      <headband-custom
        :title="'title'"
        :overline="''"
        typeScreen="markets"
        :market="i18nTermsGroups('markets', market)"
        :sector="i18nTermsGroups('sectors', sectorRandomId)"
      />
      
      <v-container class="py-10">
        <v-row v-if="!isLoad && Object.keys(attachments.files).length !== 0">

          <v-expansion-panels
            tile
            hover
            accordion
            focusable
          >
            <v-expansion-panel
              v-for="(tab, index) in Object.keys(attachments.files)"
              :key="'accordion-' + tab + '-' + index"
              expand
            >
              <v-expansion-panel-header>
                <h2 class="v-row-title display-1 d-flex align-center mb-0">
                  <span class="ml-0">
                    <span class="ml-0">
                      {{ i18nCategory(tab) }}
                    </span>
                    <small class="subtitle-1 font-weight-light">{{ $tc('theme.documentCount', [attachments.files[tab].length]) }}</small>
                  </span>
                </h2>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    cols="12" sm="6" md="4" lg="3"
                    class="mb-2"
                    v-for="file in attachments.files[tab]"
                    :key="file.fid"
                  >
                    <document :pump="file"></document>
                  </v-col>
                </v-row>
          
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-row>
        <v-row v-if="!isLoad && Object.keys(attachments.files).length === 0">
          <v-col
            cols="12" sm="6"
          >
            <v-alert
              icon="mdi-information-outline"
              prominent
              text
              type="info"
              class="mb-0"
            >
              <span v-html="$t('page.markets.message.noresult', [market[`name_${$i18n.locale.split('-')[0]}`]])" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
    <block-newsletter v-if="!isLoad" />
   </v-layout>
</template>
<script>
import Mixins from '@/core/mixins'
export default {
  name: 'DocumentsMarkets',
  mixins: [ Mixins ],
  data() {
    return {
      isLoad: true,
      market: null,
      attachments: {},
    }
  },

  components: {
    HeadbandCustom: () => import(/* webpackChunkName: "HeadbandCustom" */ '@/modules/headband/HeadbandCustom'),
    BlockNewsletter: () => import(/* webpackChunkName: "BlockNewsletter" */ '@/modules/block/BlockNewsletter'),
    Document: () => import(/* webpackChunkName: "Document" */ '@/components/layout/Document'),
  },

  mounted() {
    this.$ga.page(`/markets/${this.$route.params.market}`);
  },

  created () {
    const market = this.$route.params.market.toUpperCase()
    this.market = market

    this.handler(market)
  },

  computed: {
    sectorRandomId () {
      const findSectors = this.$store.getters["home/termsType"]('sectors')
        .filter(f => f.market === this.market)
        .map(s => s.key)
        .sort(() => Math.round(Math.random()) - 0.5)
      if (findSectors.length !== 0) {
        return findSectors[0]
      } else {
        return {
          key: 'FL-HYGIAGRO',
          id: 'HygieneAgrolimentaire',
          name_en: "",
          name_fr: "",
          market: "FL",
          count: 0,
          color: "#fff"
        }
      }
    }
  },

  methods: {
    async handler (market) {
      const response = await this.request(`/search/market/${market}`)
      this.attachments = response
      this.isLoad = false
    },
  },
  watch: {
    '$route.params.market'(newId, oldId) {
      if (newId !== oldId) {
        this.market = newId.toUpperCase()
        this.handler(newId.toUpperCase())
      }
    }
  }
}
</script>
